import React, {useState} from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import SpinnerV2 from '../Spinner/Spinner';
import { addCommittee } from '../../redux/actions/boardMemberActions';
import CommitteeForm from './CommitteeForm';
import { useEffect } from 'react';

const NewBoardMember = (props) => {
  const dispatch = useDispatch();
  const boardMembers = useSelector(state => state.boardMembers);
  const [isAdding, setIsAdding] = useState(false);
  const history = useHistory();
  
  const committee = {
    id: undefined,
    name: '',
    description: "",
    chair: '',
    chair_id: undefined,
    is_board: true        //TODO: this is to signify a committee associated w the board and not general neighborhood
  }

  useEffect(() => {
    if (isAdding && boardMembers.updating === false) {
      setIsAdding(false);
      history.replace(`/documents`)
    }
  }, [isAdding])

  const onAddCommittee = (committee) => {
    setIsAdding(true);
    dispatch(addCommittee(committee));
  }
  if (boardMembers.updating) {
    return <SpinnerV2 title="Adding new committee..." />
  }

  return (
    <CommitteeForm 
      title="Add New Board Member" 
      edit={false} 
      committee={committee} 
      onSubmit={onAddCommittee}
      onCancel={() => {history.goBack()}}
    />
  );
}
export default NewBoardMember;
